export const TEST_CASE_STATUS = {
    running: "RUNNING",
    pending: "PENDING",
    completed: "COMPLETED",
    failed: "FAILED",
    initialFailure: "INITIAL_FAILURE",
    draft: "Draft",
};
